import { Heading } from '@chakra-ui/react';
import ApplicantDebitApplicationFormHandler from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/applicant/ApplicantDebitApplicationFormHandler';
import DebitApplicationApplicantAddressFormHandler from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/applicantAddress/DebitApplicationApplicantAddressFormHandler';
import CustomerFormHandler from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/customer/CustomerFormHandler';
import RequestedCardFormHandler from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/requestedCard/RequestedCardFormHandler';
import RequestedDebitFormHandler from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/requestedDebit/RequestedDebitFormHandler';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import React from 'react';

const tabHeaders = [
  'Client',
  'Candidat',
  'Adresse\u{202F}\u{202F}Candidat',
  'Débit\u{202F}\u{202F}Demandé',
  'Carte\u{202F}\u{202F}Demandée',
];

const DebitApplicationPage = () => {
  const tabContents = React.useMemo<React.ReactNode[]>(() => [
    <CustomerFormHandler />,
    <ApplicantDebitApplicationFormHandler />,
    <DebitApplicationApplicantAddressFormHandler />,
    <RequestedDebitFormHandler />,
    <RequestedCardFormHandler />,
  ], []);

  return (
    <>
      <Heading size="md" mb={'2rem'}>
        Application Débit
      </Heading>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  );
};

export default DebitApplicationPage;
